import React from "react";

export default function ScreenerFooter() {
  return (
    <p className="screener-footer">
      PSC-17 (Gardner &amp; Kelleher) · Not a diagnostic instrument · For clinical use only
    </p>
  );
}
